"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.compareByIdAlphabet = exports.tableQuery = exports.sortDirection = exports.nextSortDirection = void 0;
function nextSortDirection(isSortDesc) {
    switch (isSortDesc) {
        case undefined:
            return false;
        case false:
            return true;
        case true:
        default:
            return undefined;
    }
}
exports.nextSortDirection = nextSortDirection;
function sortDirection(isSortDesc) {
    if (isSortDesc === undefined) {
        return isSortDesc;
    }
    return isSortDesc ? 'desc' : 'asc';
}
exports.sortDirection = sortDirection;
function tableQuery(sortBy, filters, pageIndex, pageSize, cols) {
    var mapColIdToColType = new Map();
    cols.forEach(function (c) { return mapColIdToColType.set(c.id, c.columnType); });
    var sort = sortBy.map(function (s) { return ({
        columnCode: s.id,
        columnType: mapColIdToColType.get(s.id) || 'textfield',
        direction: sortDirection(s.desc),
    }); });
    var filter = filters.reduce(function (acc, f) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[f.id] = f.value, _a)));
    }, {});
    var columns = cols.map(function (_) { return ({ columnCode: _.id.toString(), title: _.Header.toString() }); });
    return { sort: sort, filter: filter, page: pageIndex, pageSize: pageSize, columns: columns };
}
exports.tableQuery = tableQuery;
function compareByIdAlphabet(a, b) {
    return a.id.localeCompare(b.id);
}
exports.compareByIdAlphabet = compareByIdAlphabet;
